import React from 'react'
import './EmailDetailsModal.style.scss'
import { startCase } from 'lodash'
import moment from "moment"

const EmailDetailsModal = ({ email, onClose }) => {
  if (!email) return null

  return (
    <div className="email-details-modal-backdrop" onClick={onClose}>
      <div className="email-details-modal" onClick={(e) => e.stopPropagation()}>
        <div className="email-details-modal-header">
          <h2>Email Details</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="email-details-modal-body">
          <div className="email-row">
            <span className="label">To:</span>
            <span className="value">{email.ReceiverEmailAddress}</span>
          </div>
          <div className="email-row">
            <span className="label">From:</span>
            <span className="value">{email.SenderEmailAddress}</span>
          </div>
          <div className="email-row">
            <span className="label">Subject:</span>
            <span className="value">{email.Subject}</span>
          </div>
          <div className="email-row">
            <span className="label">Date:</span>
            <span className="value">{moment(email.EventDate).format('DD-MMM-YYYY h:mm A')}</span>
          </div>
          <div className="email-row">
            <span className="label">Status:</span>
            <span className="value">{startCase(email.Event)}</span>
          </div>
        </div>

        <div className="email-details-modal-footer">
          <button className="action-btn" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  )
}

export default EmailDetailsModal